import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TextField } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form"
import CustomSearchSelect from '../CustomSearchSelect'
import Grid from "@mui/material/Unstable_Grid2";
import CustomTextField from '../CustomTextField';

const ModalCantidades = ({ open, handleClose, subdisciplinas, onSubmit }) => {

    const defaultValues = {
        new_cantidadtotaldetesis: '',
        new_cantmaestriasquedirigeactualmente: '',
        new_canttesinasytrabajosquedirigeactualmente: '',
        new_canttesinasytrabfinales: '',
        new_canttesisdoctoralesdirigactualmente: '',
        new_canttesismaestriasdirigyconcult: '',
        new_experienciaeneducacinadistancia: '',
    }

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }


    return (
        <Dialog
            open={open}
            onClose={() => handleClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='md'
            fullWidth={true}
        >
            <DialogTitle>Editar información</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_cantidadtotaldetesis"
                                label="Cant. de Tesis Doctorales dirigidas y concluídas últimos 5 años"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_canttesisdoctoralesdirigactualmente"
                                label="Cant. de Tesis Doctorales que dirige actualmente"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_canttesismaestriasdirigyconcult"
                                label="Cant. de Tesis de Maestrias dirigidas y concluídas últimos 5 años"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_cantmaestriasquedirigeactualmente"
                                label="Cant. de Tesis de Maestrías que dirige actualmente"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_canttesinasytrabfinales"
                                label="Cant. de Tesinas y Trabajos Finales dirigidas y concluídas últimos 5 años"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomTextField
                                Component={TextField}
                                name="new_canttesinasytrabajosquedirigeactualmente"
                                label="Cant. de Tesinas y Trabajos Finales que dirige actualmente"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <CustomTextField
                                Component={TextField}
                                name="new_experienciaeneducacinadistancia"
                                label="Experiencia en educación a distancia"
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Actualizar</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalCantidades